/**
 * @generated SignedSource<<1f02ae5cf24eab326d2c2dfa2651350e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type EngagementEventKind = "DISMISSED" | "DWELL" | "FLOORPLAN_OPENED" | "OPENED" | "PHOTO_SCROLL" | "RETURNED" | "SAVED" | "UNSAVED" | "WILDCARD_SHOWN" | "%future added value";
export type FitBand = "CAPPED" | "EARLY" | "GOOD" | "MIXED" | "NOT_SCORED" | "POOR" | "STRONG" | "%future added value";
export type InspectedAxisStatus = "BELOW_BAR" | "NOTHING_TO_WIDEN" | "NOT_ASSESSED" | "OFFER" | "TURNED_OFF" | "%future added value";
export type InspectedCandidateStatus = "ALREADY_HELD" | "CONFIRMED" | "ELIGIBLE" | "REJECTED" | "%future added value";
export type InspectedDecisionKind = "NO" | "SWIPE" | "YES" | "%future added value";
export type InspectedInferenceOutcome = "COOLING_DOWN" | "EVERY_SUGGESTION_SETTLED" | "NOT_ENOUGH_INTERESTED_HOMES" | "NO_PATTERN_FOUND" | "ON_OFFER" | "SEARCH_UNAVAILABLE" | "%future added value";
export type InspectedPendingDirection = "ANOTHER_MEMBER" | "PARTNER" | "THIS_MEMBER" | "%future added value";
export type InspectedWideningOutcome = "ALREADY_CONFIRMED" | "AXES_TURNED_OFF" | "BELOW_BAR" | "COOLING_DOWN" | "INFERENCE_HOLDS_SLOT" | "NOTHING_TO_WIDEN" | "NOT_COVERED" | "NO_ASSESSED_AXES" | "ON_OFFER" | "RENTING" | "SUPPRESSED" | "UNSCORED" | "%future added value";
export type MoverDirection = "DOWN" | "UP" | "%future added value";
export type NotPlannedReason = "NOT_COVERED" | "RENTING" | "UNSCORED" | "%future added value";
export type PreferenceHouseholdStatus = "APPLIED" | "DECLINED" | "PENDING" | "%future added value";
export type PreferenceOrigin = "INFERENCE" | "QUESTION" | "STATED" | "WIDENING" | "%future added value";
export type QuestionKind = "FIRMNESS" | "KEY_PLACE" | "PRIORITY" | "WHAT_KIND" | "%future added value";
export type QuestionTodayReason = "NOTHING_WORTH_ASKING" | "NOT_A_QUESTION_DAY" | "OFFERED" | "QUIET_AFTER_ANSWER" | "SCORING_WITHHELD" | "SEARCH_NOT_COVERED" | "SNOOZED" | "%future added value";
export type ResultsChangedCardState = "CARD_LAPSED" | "CARD_NOTED" | "NO_BASELINE" | "NO_CARD_NOTED" | "%future added value";
export type ResultsChangedPending = "CARD_OWED" | "NOT_EVALUATED" | "NOT_RANKED" | "NO_CARD" | "%future added value";
export type ResultsChangedWrite = "CAPTURE" | "FOLLOW" | "NONE" | "NOTE_CARD_SHOWN" | "%future added value";
export type WildcardAxis = "AREA" | "BEDS" | "PRICE" | "TYPE" | "%future added value";
export type WildcardAxisOffSource = "FIRM_ANSWER" | "SHOW_FEWER" | "%future added value";
export type WildcardPlanState = "NOT_PLANNED" | "PLANNED" | "%future added value";
export type WildcardRateState = "BACKED_OFF" | "BASE" | "NONE" | "RAISED" | "%future added value";
export type homeFeedQueriesInspectionQuery$variables = {
  memberAccountId: any;
  searchId: any;
  vaultId: any;
};
export type homeFeedQueriesInspectionQuery$data = {
  readonly homeFeedInspection: {
    readonly engagement: {
      readonly cap: number;
      readonly events: ReadonlyArray<{
        readonly kind: EngagementEventKind;
        readonly listingId: any;
        readonly occurredUtc: any;
        readonly quantity: number | null | undefined;
        readonly wildcardAxis: WildcardAxis | null | undefined;
      }>;
      readonly truncated: boolean;
      readonly windowDays: number;
    } | null | undefined;
    readonly evaluatedAt: any;
    readonly homeFeedOn: boolean;
    readonly inferences: {
      readonly candidates: ReadonlyArray<{
        readonly evidence: string;
        readonly key: string;
        readonly status: InspectedCandidateStatus;
        readonly suggestion: string;
      }>;
      readonly confirmations: ReadonlyArray<{
        readonly confirmedUtc: any;
        readonly key: string;
      }>;
      readonly countdown: {
        readonly cooldownHomes: number;
        readonly homesSinceLastDecision: number;
        readonly lastDecisionIsWidening: boolean;
        readonly lastDecisionKey: string | null | undefined;
        readonly lastDecisionKind: InspectedDecisionKind | null | undefined;
        readonly lastDecisionUtc: any | null | undefined;
        readonly moreHomes: number;
        readonly offerableNow: boolean;
      };
      readonly dismissals: ReadonlyArray<{
        readonly dismissedUtc: any;
        readonly key: string;
      }>;
      readonly engagedHomes: number;
      readonly interestedHomes: number;
      readonly minInterestedHomes: number;
      readonly onOffer: {
        readonly evidence: string;
        readonly homes: ReadonlyArray<{
          readonly address: string;
          readonly indexedListingId: any;
          readonly matches: boolean;
        }>;
        readonly interested: number;
        readonly key: string;
        readonly matching: number;
        readonly skippedEvidence: string | null | undefined;
        readonly suggestion: string;
      } | null | undefined;
      readonly outcome: InspectedInferenceOutcome;
      readonly rejections: ReadonlyArray<{
        readonly key: string;
        readonly mayReturnUtc: any;
        readonly rejectedUtc: any;
        readonly stillQuiet: boolean;
      }>;
    } | null | undefined;
    readonly memberAccountId: any;
    readonly preferences: {
      readonly household: {
        readonly conflicts: ReadonlyArray<{
          readonly householdValue: string | null | undefined;
          readonly kind: string;
          readonly subject: string;
          readonly views: ReadonlyArray<{
            readonly householdStatus: PreferenceHouseholdStatus;
            readonly memberAccountId: any;
            readonly overriddenByAccountId: any | null | undefined;
            readonly value: string;
          }>;
        }>;
        readonly held: ReadonlyArray<{
          readonly kind: string;
          readonly memberAccountIds: ReadonlyArray<any>;
          readonly subject: string;
          readonly value: string;
        }>;
        readonly pending: ReadonlyArray<{
          readonly householdValue: string | null | undefined;
          readonly kind: string;
          readonly subject: string;
          readonly views: ReadonlyArray<{
            readonly householdStatus: PreferenceHouseholdStatus;
            readonly memberAccountId: any;
            readonly overriddenByAccountId: any | null | undefined;
            readonly value: string;
          }>;
        }>;
      };
      readonly items: ReadonlyArray<{
        readonly householdStatus: PreferenceHouseholdStatus;
        readonly kind: string;
        readonly overriddenByAccountId: any | null | undefined;
        readonly source: PreferenceOrigin;
        readonly statedAt: any;
        readonly subject: string;
        readonly value: string;
      }>;
    } | null | undefined;
    readonly questions: {
      readonly latestAnswers: ReadonlyArray<{
        readonly answeredUtc: any;
        readonly key: string;
        readonly value: string;
      }>;
      readonly nextDay: {
        readonly day: any;
        readonly from: any;
        readonly homesBefore: number;
        readonly prefersNonRanking: boolean;
      } | null | undefined;
      readonly others: ReadonlyArray<{
        readonly key: string;
        readonly kind: QuestionKind;
        readonly mostReordered: number;
        readonly prompt: string;
        readonly totalReordered: number;
      }>;
      readonly picked: {
        readonly afterHomes: number;
        readonly answers: ReadonlyArray<{
          readonly label: string;
          readonly reordered: number;
        }>;
        readonly key: string;
        readonly kind: QuestionKind;
        readonly mostReordered: number;
        readonly poolSize: number;
        readonly prompt: string;
        readonly todayPrefersNonRanking: boolean;
        readonly totalReordered: number;
      } | null | undefined;
      readonly pickedOnNextQuestionDay: string | null | undefined;
      readonly scanDays: number;
      readonly snoozedUntil: any | null | undefined;
      readonly todayReason: QuestionTodayReason;
      readonly todayUntil: any | null | undefined;
    } | null | undefined;
    readonly resultsChanged: {
      readonly baselineMovedUtc: any | null | undefined;
      readonly card: {
        readonly movers: ReadonlyArray<{
          readonly address: string;
          readonly direction: MoverDirection;
          readonly fitBand: FitBand;
          readonly listingId: any;
          readonly places: number;
          readonly previousRank: number;
          readonly rank: number;
          readonly reason: string;
          readonly score: number;
        }>;
        readonly title: string;
      } | null | undefined;
      readonly cardLapsesUtc: any | null | undefined;
      readonly cardNotedSinceUtc: any | null | undefined;
      readonly pending: ResultsChangedPending;
      readonly preferencesChangedSinceBaseline: boolean | null | undefined;
      readonly readWouldWrite: ResultsChangedWrite | null | undefined;
      readonly state: ResultsChangedCardState;
    } | null | undefined;
    readonly searchId: any;
    readonly vaultId: any;
    readonly widening: {
      readonly axes: ReadonlyArray<{
        readonly axis: WildcardAxis;
        readonly interested: number;
        readonly skipped: number;
        readonly status: InspectedAxisStatus;
      }>;
      readonly candidates: ReadonlyArray<{
        readonly axis: WildcardAxis;
        readonly evidence: string;
        readonly key: string;
        readonly status: InspectedCandidateStatus;
        readonly suggestion: string;
      }>;
      readonly confirmations: ReadonlyArray<{
        readonly confirmedUtc: any;
        readonly key: string;
      }>;
      readonly countdown: {
        readonly cooldownHomes: number;
        readonly homesSinceLastDecision: number;
        readonly lastDecisionIsWidening: boolean;
        readonly lastDecisionKey: string | null | undefined;
        readonly lastDecisionKind: InspectedDecisionKind | null | undefined;
        readonly lastDecisionUtc: any | null | undefined;
        readonly moreHomes: number;
        readonly offerableNow: boolean;
      } | null | undefined;
      readonly dismissals: ReadonlyArray<{
        readonly dismissedUtc: any;
        readonly key: string;
      }>;
      readonly holdingInferenceKey: string | null | undefined;
      readonly interestedWildcards: number;
      readonly minInterestedWildcards: number;
      readonly onOffer: {
        readonly axis: WildcardAxis;
        readonly evidence: string;
        readonly homes: ReadonlyArray<{
          readonly address: string;
          readonly indexedListingId: any;
        }>;
        readonly interested: number;
        readonly key: string;
        readonly shown: number;
        readonly suggestion: string;
      } | null | undefined;
      readonly outcome: InspectedWideningOutcome;
      readonly pendingAgreements: ReadonlyArray<{
        readonly kind: string;
        readonly statedUtc: any;
        readonly subject: string;
        readonly value: string;
        readonly waitingOn: InspectedPendingDirection;
        readonly wideningKey: string | null | undefined;
      }>;
      readonly rejections: ReadonlyArray<{
        readonly key: string;
        readonly mayReturnUtc: any;
        readonly rejectedUtc: any;
        readonly stillQuiet: boolean;
      }>;
    } | null | undefined;
    readonly wildcards: {
      readonly axesOff: ReadonlyArray<{
        readonly axis: WildcardAxis;
        readonly sinceUtc: any;
        readonly source: WildcardAxisOffSource;
      }>;
      readonly notPlannedReason: NotPlannedReason | null | undefined;
      readonly pacing: {
        readonly activeAxes: ReadonlyArray<WildcardAxis>;
        readonly baseRate: number;
        readonly lookbackDays: number;
        readonly oneIn: number | null | undefined;
        readonly paused: ReadonlyArray<{
          readonly axis: WildcardAxis;
          readonly untilUtc: any;
        }>;
        readonly rate: number;
        readonly rateState: WildcardRateState;
        readonly rateWindow: number;
        readonly recent: ReadonlyArray<{
          readonly atUtc: any;
          readonly axis: WildcardAxis;
          readonly skipped: boolean;
        }>;
        readonly timesShown: number;
      };
      readonly planState: WildcardPlanState;
      readonly priceFirm: {
        readonly answer: string;
        readonly answerKey: string;
        readonly answeredUtc: any | null | undefined;
        readonly isFirm: boolean;
      };
    } | null | undefined;
  };
};
export type homeFeedQueriesInspectionQuery = {
  response: homeFeedQueriesInspectionQuery$data;
  variables: homeFeedQueriesInspectionQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "memberAccountId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "vaultId"
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "memberAccountId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "outcome",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "InspectedOfferCountdown",
  "kind": "LinkedField",
  "name": "countdown",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastDecisionUtc",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastDecisionKey",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastDecisionKind",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastDecisionIsWidening",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cooldownHomes",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "homesSinceLastDecision",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "moreHomes",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "offerableNow",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "suggestion",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "evidence",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "interested",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "indexedListingId",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "address",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "InspectedRejection",
  "kind": "LinkedField",
  "name": "rejections",
  "plural": true,
  "selections": [
    (v6/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rejectedUtc",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mayReturnUtc",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "stillQuiet",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "InspectedDismissal",
  "kind": "LinkedField",
  "name": "dismissals",
  "plural": true,
  "selections": [
    (v6/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dismissedUtc",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "InspectedConfirmation",
  "kind": "LinkedField",
  "name": "confirmations",
  "plural": true,
  "selections": [
    (v6/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "confirmedUtc",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "axis",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "skipped",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "subject",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "prompt",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mostReordered",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalReordered",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "answeredUtc",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "source",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "listingId",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "householdStatus",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "overriddenByAccountId",
  "storageKey": null
},
v29 = [
  (v18/*: any*/),
  (v19/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "householdValue",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "PreferenceView",
    "kind": "LinkedField",
    "name": "views",
    "plural": true,
    "selections": [
      (v3/*: any*/),
      (v20/*: any*/),
      (v27/*: any*/),
      (v28/*: any*/)
    ],
    "storageKey": null
  }
],
v30 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "memberAccountId",
        "variableName": "memberAccountId"
      },
      {
        "kind": "Variable",
        "name": "searchId",
        "variableName": "searchId"
      },
      {
        "kind": "Variable",
        "name": "vaultId",
        "variableName": "vaultId"
      }
    ],
    "concreteType": "HomeFeedInspection",
    "kind": "LinkedField",
    "name": "homeFeedInspection",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "vaultId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "searchId",
        "storageKey": null
      },
      (v3/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "evaluatedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "homeFeedOn",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "InspectedInferences",
        "kind": "LinkedField",
        "name": "inferences",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "interestedHomes",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "engagedHomes",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "minInterestedHomes",
            "storageKey": null
          },
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "InspectedInferenceOffer",
            "kind": "LinkedField",
            "name": "onOffer",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "skippedEvidence",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "matching",
                "storageKey": null
              },
              (v9/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "InspectedEvidenceHome",
                "kind": "LinkedField",
                "name": "homes",
                "plural": true,
                "selections": [
                  (v10/*: any*/),
                  (v11/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "matches",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "InspectedInferenceCandidate",
            "kind": "LinkedField",
            "name": "candidates",
            "plural": true,
            "selections": [
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v12/*: any*/)
            ],
            "storageKey": null
          },
          (v13/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "InspectedWidening",
        "kind": "LinkedField",
        "name": "widening",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "holdingInferenceKey",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "interestedWildcards",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "minInterestedWildcards",
            "storageKey": null
          },
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "InspectedWideningOffer",
            "kind": "LinkedField",
            "name": "onOffer",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v16/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "shown",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "InspectedWideningHome",
                "kind": "LinkedField",
                "name": "homes",
                "plural": true,
                "selections": [
                  (v10/*: any*/),
                  (v11/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "InspectedWideningAxis",
            "kind": "LinkedField",
            "name": "axes",
            "plural": true,
            "selections": [
              (v16/*: any*/),
              (v12/*: any*/),
              (v9/*: any*/),
              (v17/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "InspectedWideningCandidate",
            "kind": "LinkedField",
            "name": "candidates",
            "plural": true,
            "selections": [
              (v6/*: any*/),
              (v16/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v12/*: any*/)
            ],
            "storageKey": null
          },
          (v13/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "InspectedPendingWidening",
            "kind": "LinkedField",
            "name": "pendingAgreements",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "waitingOn",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "wideningKey",
                "storageKey": null
              },
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "statedUtc",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "InspectedQuestions",
        "kind": "LinkedField",
        "name": "questions",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "todayReason",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "todayUntil",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "scanDays",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "snoozedUntil",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "pickedOnNextQuestionDay",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "InspectedNextQuestionDay",
            "kind": "LinkedField",
            "name": "nextDay",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "day",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "from",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "homesBefore",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "prefersNonRanking",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "InspectedQuestionPick",
            "kind": "LinkedField",
            "name": "picked",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v18/*: any*/),
              (v21/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "poolSize",
                "storageKey": null
              },
              (v22/*: any*/),
              (v23/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "afterHomes",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "todayPrefersNonRanking",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "InspectedQuestionAnswer",
                "kind": "LinkedField",
                "name": "answers",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "label",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "reordered",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "InspectedRankedQuestion",
            "kind": "LinkedField",
            "name": "others",
            "plural": true,
            "selections": [
              (v6/*: any*/),
              (v18/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "InspectedLatestAnswer",
            "kind": "LinkedField",
            "name": "latestAnswers",
            "plural": true,
            "selections": [
              (v6/*: any*/),
              (v20/*: any*/),
              (v24/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "InspectedWildcards",
        "kind": "LinkedField",
        "name": "wildcards",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "planState",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notPlannedReason",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "InspectedWildcardPacing",
            "kind": "LinkedField",
            "name": "pacing",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "timesShown",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lookbackDays",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "rate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "oneIn",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "baseRate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "rateState",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "activeAxes",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "rateWindow",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "InspectedAxisPause",
                "kind": "LinkedField",
                "name": "paused",
                "plural": true,
                "selections": [
                  (v16/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "untilUtc",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "InspectedWildcardOutcome",
                "kind": "LinkedField",
                "name": "recent",
                "plural": true,
                "selections": [
                  (v16/*: any*/),
                  (v17/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "atUtc",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "InspectedAxisOff",
            "kind": "LinkedField",
            "name": "axesOff",
            "plural": true,
            "selections": [
              (v16/*: any*/),
              (v25/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sinceUtc",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "InspectedPriceFirmness",
            "kind": "LinkedField",
            "name": "priceFirm",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isFirm",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "answerKey",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "answer",
                "storageKey": null
              },
              (v24/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "InspectedResultsChanged",
        "kind": "LinkedField",
        "name": "resultsChanged",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "pending",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "readWouldWrite",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "InspectedPendingCard",
            "kind": "LinkedField",
            "name": "card",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ResultsMover",
                "kind": "LinkedField",
                "name": "movers",
                "plural": true,
                "selections": [
                  (v26/*: any*/),
                  (v11/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "direction",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "rank",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "previousRank",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "places",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "score",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "reason",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "fitBand",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "state",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "baselineMovedUtc",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cardNotedSinceUtc",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cardLapsesUtc",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "preferencesChangedSinceBaseline",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "InspectedEngagement",
        "kind": "LinkedField",
        "name": "engagement",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "windowDays",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cap",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "truncated",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "InspectedEngagementEvent",
            "kind": "LinkedField",
            "name": "events",
            "plural": true,
            "selections": [
              (v18/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "occurredUtc",
                "storageKey": null
              },
              (v26/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "quantity",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "wildcardAxis",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "InspectedPreferences",
        "kind": "LinkedField",
        "name": "preferences",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "InspectedPreference",
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": [
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v25/*: any*/),
              (v27/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "statedAt",
                "storageKey": null
              },
              (v28/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "InspectedHouseholdSummary",
            "kind": "LinkedField",
            "name": "household",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PreferenceHeldLine",
                "kind": "LinkedField",
                "name": "held",
                "plural": true,
                "selections": [
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "memberAccountIds",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PreferencePending",
                "kind": "LinkedField",
                "name": "pending",
                "plural": true,
                "selections": (v29/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PreferenceConflict",
                "kind": "LinkedField",
                "name": "conflicts",
                "plural": true,
                "selections": (v29/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "homeFeedQueriesInspectionQuery",
    "selections": (v30/*: any*/),
    "type": "AdminQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "homeFeedQueriesInspectionQuery",
    "selections": (v30/*: any*/)
  },
  "params": {
    "cacheID": "a4c38f246c4cf44e8b2e22cc7a101388",
    "id": null,
    "metadata": {},
    "name": "homeFeedQueriesInspectionQuery",
    "operationKind": "query",
    "text": "query homeFeedQueriesInspectionQuery(\n  $vaultId: UUID!\n  $searchId: UUID!\n  $memberAccountId: UUID!\n) {\n  homeFeedInspection(vaultId: $vaultId, searchId: $searchId, memberAccountId: $memberAccountId) {\n    vaultId\n    searchId\n    memberAccountId\n    evaluatedAt\n    homeFeedOn\n    inferences {\n      outcome\n      interestedHomes\n      engagedHomes\n      minInterestedHomes\n      countdown {\n        lastDecisionUtc\n        lastDecisionKey\n        lastDecisionKind\n        lastDecisionIsWidening\n        cooldownHomes\n        homesSinceLastDecision\n        moreHomes\n        offerableNow\n      }\n      onOffer {\n        key\n        suggestion\n        evidence\n        skippedEvidence\n        matching\n        interested\n        homes {\n          indexedListingId\n          address\n          matches\n        }\n      }\n      candidates {\n        key\n        suggestion\n        evidence\n        status\n      }\n      rejections {\n        key\n        rejectedUtc\n        mayReturnUtc\n        stillQuiet\n      }\n      dismissals {\n        key\n        dismissedUtc\n      }\n      confirmations {\n        key\n        confirmedUtc\n      }\n    }\n    widening {\n      outcome\n      holdingInferenceKey\n      interestedWildcards\n      minInterestedWildcards\n      countdown {\n        lastDecisionUtc\n        lastDecisionKey\n        lastDecisionKind\n        lastDecisionIsWidening\n        cooldownHomes\n        homesSinceLastDecision\n        moreHomes\n        offerableNow\n      }\n      onOffer {\n        key\n        axis\n        suggestion\n        evidence\n        interested\n        shown\n        homes {\n          indexedListingId\n          address\n        }\n      }\n      axes {\n        axis\n        status\n        interested\n        skipped\n      }\n      candidates {\n        key\n        axis\n        suggestion\n        evidence\n        status\n      }\n      rejections {\n        key\n        rejectedUtc\n        mayReturnUtc\n        stillQuiet\n      }\n      dismissals {\n        key\n        dismissedUtc\n      }\n      confirmations {\n        key\n        confirmedUtc\n      }\n      pendingAgreements {\n        waitingOn\n        wideningKey\n        kind\n        subject\n        value\n        statedUtc\n      }\n    }\n    questions {\n      todayReason\n      todayUntil\n      scanDays\n      snoozedUntil\n      pickedOnNextQuestionDay\n      nextDay {\n        day\n        from\n        homesBefore\n        prefersNonRanking\n      }\n      picked {\n        key\n        kind\n        prompt\n        poolSize\n        mostReordered\n        totalReordered\n        afterHomes\n        todayPrefersNonRanking\n        answers {\n          label\n          reordered\n        }\n      }\n      others {\n        key\n        kind\n        prompt\n        mostReordered\n        totalReordered\n      }\n      latestAnswers {\n        key\n        value\n        answeredUtc\n      }\n    }\n    wildcards {\n      planState\n      notPlannedReason\n      pacing {\n        timesShown\n        lookbackDays\n        rate\n        oneIn\n        baseRate\n        rateState\n        activeAxes\n        rateWindow\n        paused {\n          axis\n          untilUtc\n        }\n        recent {\n          axis\n          skipped\n          atUtc\n        }\n      }\n      axesOff {\n        axis\n        source\n        sinceUtc\n      }\n      priceFirm {\n        isFirm\n        answerKey\n        answer\n        answeredUtc\n      }\n    }\n    resultsChanged {\n      pending\n      readWouldWrite\n      card {\n        title\n        movers {\n          listingId\n          address\n          direction\n          rank\n          previousRank\n          places\n          score\n          reason\n          fitBand\n        }\n      }\n      state\n      baselineMovedUtc\n      cardNotedSinceUtc\n      cardLapsesUtc\n      preferencesChangedSinceBaseline\n    }\n    engagement {\n      windowDays\n      cap\n      truncated\n      events {\n        kind\n        occurredUtc\n        listingId\n        quantity\n        wildcardAxis\n      }\n    }\n    preferences {\n      items {\n        kind\n        subject\n        value\n        source\n        householdStatus\n        statedAt\n        overriddenByAccountId\n      }\n      household {\n        held {\n          kind\n          subject\n          value\n          memberAccountIds\n        }\n        pending {\n          kind\n          subject\n          householdValue\n          views {\n            memberAccountId\n            value\n            householdStatus\n            overriddenByAccountId\n          }\n        }\n        conflicts {\n          kind\n          subject\n          householdValue\n          views {\n            memberAccountId\n            value\n            householdStatus\n            overriddenByAccountId\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7078d6f339b1ab5d12b9d5eb49520180";

export default node;
